export const calcularTotalesDTE = (lineas = [], tipoDte = '01', aplicaRetencion = false) => {
  let subtotalBruto = 0;
  let totalDescuentos = 0;

  lineas.forEach((linea) => {
    const cant = parseFloat(linea.cantidad) || 0;
    const prec = parseFloat(linea.precio_unitario) || 0;
    const desc = parseFloat(linea.monto_descuento) || 0;

    if (tipoDte === '03' || tipoDte === '11') {
      subtotalBruto += (cant * prec) / 1.13;
      totalDescuentos += desc / 1.13;
    } else {
      subtotalBruto += cant * prec;
      totalDescuentos += desc;
    }
  });

  const subtotalGravado = Math.max(0, subtotalBruto - totalDescuentos);
  let montoIva = 0;
  let montoRetencion1 = 0;
  let totalPagar = 0;

  if (tipoDte === '03') {
    montoIva = subtotalGravado * 0.13;

    // Retención 1% IVA: Solo CCF, si la bandera está activa y Subtotal >= $100.00
    if (aplicaRetencion && subtotalGravado >= 100.00) {
      montoRetencion1 = subtotalGravado * 0.01;
    }

    totalPagar = subtotalGravado + montoIva - montoRetencion1;
  } else if (tipoDte === '01') {
    totalPagar = subtotalGravado;
    montoIva = subtotalGravado - (subtotalGravado / 1.13);
  } else if (tipoDte === '11') {
    montoIva = 0;
    totalPagar = subtotalGravado;
  }

  return {
    subtotalBruto,
    totalDescuentos,
    subtotal: subtotalGravado,
    montoIva,
    montoRetencion1,
    totalPagar,
  };
};